export const CODE_COUNT: number = 6;

export const NUMBER_KEY: any = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "0"];